import { z } from 'zod';
import { personName } from '../_shared/person-name.js';
const EMAIL_REQUIRED = "L'adresse email est requise.";
const EMAIL_INVALID = 'Veuillez saisir une adresse email valide.';
const DOSSIER_REQUIRED = 'Le numéro de dossier est requis.';
const LASTNAME_REQUIRED = 'Le nom de famille est requis.';
const AMOUNT_INT = 'Le montant doit être un nombre entier (en centimes).';
const AMOUNT_MIN = 'Le montant doit être supérieur à 0.';
export const initiateDepositSchema = z.object({
    email: z.string().min(1, EMAIL_REQUIRED).email(EMAIL_INVALID),
    lastName: z.string().min(1, LASTNAME_REQUIRED),
    amount: z.number().int(AMOUNT_INT).min(1, AMOUNT_MIN),
    dossierNumber: z.string().min(1, DOSSIER_REQUIRED),
});
export const initiateLegacyDepositSchema = z.object({
    email: z.string().min(1, EMAIL_REQUIRED).email(EMAIL_INVALID),
    firstName: personName(),
    lastName: personName(),
    amountCents: z.number().int(AMOUNT_INT).min(1, AMOUNT_MIN),
    comment: z.string().optional(),
    dossierNumber: z.string().min(1, DOSSIER_REQUIRED),
    phone: z.string().min(1, 'Le numéro de téléphone est requis.'),
});
export const lookupBookingSchema = z.object({
    email: z.string().min(1, EMAIL_REQUIRED).email(EMAIL_INVALID),
    lastName: z.string().min(1, LASTNAME_REQUIRED),
    dossierNumber: z.string().min(1, DOSSIER_REQUIRED),
});
